import React from 'react';

import Page from 'components/page/Page';
import PasswordResetForm from '../components/PasswordResetForm';
import AccessContainerHeader from '../components/access-container/access-container-header/AccessContainerHeader';
import AccessContainer from '../components/access-container/AccessContainer';
import { t } from 'utils/language';

import '../common/access-form.scss';

import type { LocationWindow } from 'types';

type Props = {
  params: Record<string, string>,
  location: LocationWindow
};

const PasswordResetPage = ({ location, params }: Props) => {
  const pageTitleByAction = {
    reset: t('access_reset_password_page'),
    create: t('signup_set_new_password_title')
  };
  const accessContainerHeaderTitleByAction = {
    reset: t('access_reset_password_page'),
    create: t('access_create_password_page')
  };

  const resetButtonLabelByAction = {
    reset: t('reset_password'),
    create: t('signup_create_password_button')
  };

  const action = location.query.action || 'reset';
  const pageTitle = pageTitleByAction[action];
  const accessContainerHeaderTitle = accessContainerHeaderTitleByAction[action];
  const resetButtonLabel = resetButtonLabelByAction[action];

  return (
    <Page
      documentTitle={pageTitle}
    >
      <AccessContainer type="request-password">
        <AccessContainerHeader title={accessContainerHeaderTitle} />
        {
          action === 'create' && (
            <div className="access-form__description">
              <p>{t('signup_password_welcome')}</p>
            </div>
          )
        }
        <PasswordResetForm
          location={location}
          params={params}
          showTermsAndConditions={action === 'create'}
          resetButtonLabel={resetButtonLabel}
        />
      </AccessContainer>
    </Page>
  );
};

export default PasswordResetPage;
